<template>
  <h1 class="title has-text-centered is-spaced">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    {{ productsQty + scaleProductsQty }}
    {{ $t("products.products") }} &nbsp;

    <button class="button" @click="$emit('get-products')">
      <b-icon icon="sync-alt"></b-icon>
    </button>
    &nbsp;

    <br v-if="c1" />

    <span
      :style="
        c1
          ? 'position: relative; top: 0.1rem;'
          : 'position: relative; top: -0.95rem;'
      "
      class="field has-addons"
      style="display: inline-block;"
      v-if="
        permissions.downloadStoresProductsReport ||
          permissions.downloadAllOniiProductsReport ||
          permissions.downloadCompletePlanogramReport ||
          permissions.downloadRefillPlanogramReport
      "
    >
      <button
        class="button"
        @click="downloadProductsReport"
        style="position: relative; top: 0.95rem;"
      >
        <b-icon icon="save"></b-icon>
      </button>

      <b-select
        style="display: inline-block;"
        v-model="productsFilter"
        @input="$emit('update-products-filter', productsFilter)"
      >
        <option
          value="store-products"
          v-if="permissions.downloadStoresProductsReport"
        >
          {{ $t("products.storeCatalog") }}
        </option>

        <option
          value="all-stores-products"
          v-if="permissions.downloadStoresProductsReport"
        >
          {{ $t("products.allStoresCatalog") }}
        </option>

        <option
          value="management-planogram"
          v-if="
            storeBeingManaged.configs.planogram &&
              permissions.downloadCompletePlanogramReport
          "
        >
          {{ $t("products.completePlanogram") }}
        </option>

        <option
          value="all-stores-management-planogram"
          v-if="
            storeBeingManaged.configs.planogram &&
              permissions.downloadCompletePlanogramReport
          "
        >
          {{ $t("products.allStoresCompletePlanogram") }}
        </option>

        <option
          value="operational-planogram"
          v-if="
            storeBeingManaged.configs.planogram &&
              permissions.downloadRefillPlanogramReport
          "
        >
          {{ $t("products.repositionPlanogram") }}
        </option>

        <option
          value="all-stores-operational-planogram"
          v-if="
            storeBeingManaged.configs.planogram &&
              permissions.downloadRefillPlanogramReport
          "
        >
          {{ $t("products.allStoresRepositionPlanogram") }}
        </option>

        <option
          value="all-products"
          v-if="permissions.downloadAllOniiProductsReport"
        >
          {{ $t("products.allProductsOnii") }}
        </option>
      </b-select>
    </span>
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";

export default {
  props: ["storeBeingManaged", "productsQty", "scaleProductsQty"],

  mixins: [common, responsive],

  data() {
    return {
      isLoading: false,
      productsFilter: "store-products"
    };
  },

  methods: {
    downloadProductsReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadProductsReport", {
          storeId: this.storeBeingManaged._id,
          storeName: this.storeBeingManaged.storeInfo.name,
          productsFilter: this.productsFilter
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["permissions"]),

    c1() {
      return this.windowWidth < 700;
    }
  },

  mounted() {
    this.filter = this.permissions.downloadStoresProductsReport
      ? "store-products"
      : this.permissions.downloadAllOniiProductsReport
      ? "all-products"
      : this.permissions.downloadCompletePlanogramReport
      ? "management-planogram"
      : this.permissions.downloadRefillPlanogramReport
      ? "operational-planogram"
      : null;
  }
};
</script>
